import { VisitingHoursDepartmentResource } from "app/models/VisitingHoursDepartmentResource";
import { CMSResource } from "app/resources/cmsresource";

export class VisitingHoursDepartmentListResource extends CMSResource {
    visitingHoursDepartmentListResource: VisitingHoursDepartmentResource[];
}